import { css } from '@linaria/core'

export const elSideNav = css`
  width: auto;
  transform: none !important;
  width: auto !important;
`
export const elSideNavItems = css`
  display: grid;
  column-gap: 3.5rem;
  grid-template-columns: 1fr 1rem;
  border-left: none !important;
  border-radius: 6px;
  padding: 0.5rem 1rem !important;
`

export const elSideContiner = css`
  position: relative;
`

export const elTiles = css`
  height: fit-content;
  position: sticky;
  top: 74px;
`
